import { removeFromTerm } from './removeFromTerm';
import { removeFromTerms } from './removeFromTerms';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { EJsonQueryType } from '../../types/jsonQuery/term';

/**
 * Утилита для удаления одного jsonQuery из другого
 * для полей типа Term, если их значения совпадают, в результируещем jsonQuery поле будет удалено
 * для полей типа Terms - все переданные для удаления значения массива, которые переда
 * *
 * @export
 * @param {IJsonQuery} jsonQuery - Основной объект jsonQuery
 * @param {IJsonQuery} removeFromJsonQuery - новый jsonQuery, его значения будут добавляться в основной
 * @returns {IJsonQuery}
 */
export const extractJsonQuery = (jsonQuery: IJsonQuery, removeFromJsonQuery: IJsonQuery) => {
  const jsonQueryMap = new Map(Object.entries(jsonQuery));
  const removeFromJsonQueryMap = new Map(Object.entries(removeFromJsonQuery));

  for (const entry of removeFromJsonQueryMap) {
    const [removeFromJsonQueryKey, removeFromJsonQueryFilter] = entry;
    const jsonQueryFilter = jsonQueryMap.get(removeFromJsonQueryKey);
    const jsonQueryType = removeFromJsonQueryFilter?.type || jsonQueryFilter?.type;

    if (jsonQueryType === EJsonQueryType.Term) {
      const newTerm = removeFromTerm({ jsonQuery: jsonQueryFilter, removeFromJsonQuery: removeFromJsonQueryFilter });
      jsonQueryMap.set(removeFromJsonQueryKey, newTerm);
    }

    if (jsonQueryType === EJsonQueryType.Terms) {
      const newTerms = removeFromTerms({ jsonQuery: jsonQueryFilter, removeFromJsonQuery: removeFromJsonQueryFilter });
      jsonQueryMap.set(removeFromJsonQueryKey, newTerms);
    }
  }

  return Object.fromEntries(jsonQueryMap);
};
